import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs';
import { getMetaValue } from "../plugins/src/metadata"

export default class extends Controller {
  connect() {
    Sortable.create(this.element, {
      onEnd: this.onEnd.bind(this),
      handle: ".sortable-handle",
      animation: 150,
      forceFallback: true,
    });
  }

  onEnd(event) {
    let url = event.item.dataset.rowSortablesPath
    let data = {
      row: {
          page_id: event.to.dataset.pageSortablesPageId,
          row_order_position: event.newIndex,
        }
    }

    fetch(url, {
        method: 'PUT',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": getMetaValue("csrf-token"),
        },
        body: JSON.stringify(data)
    })
      .then(response => response.json())
      .catch(error => console.error(error));
  }

}
